<style>
    .ag-theme-material .ag-cell {
        line-height: 35px !important;
    }
</style>

<template>
    <div id="ag-grid-demo">
        <vx-card>
            <div class="flex flex-wrap justify-between items-center">
                <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left"></div>
                <div
                    class="flex flex-wrap items-center justify-between ag-grid-table-actions-right"
                >
                    <vs-button
                        @click="refreshData"
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="refresh"
                    >Refresh</vs-button>
                    <vs-button @click="add = { qty: '', type: '' }; showAdd = true" class="btn mb-4 md:mb-0 mr-1" icon="add">Add</vs-button>
                    <!-- <vs-button :to="{ name: 'master-container-view', params: {id: selectedId} }" class="mb-4 md:mb-0 mr-1" icon="remove_red_eye" :disabled="selectedId ? false : true">View</vs-button> -->
                    <!-- <vs-button class="mb-4 md:mb-0 mr-1" color="warning">Edit</vs-button> -->
                    <vs-button
                        class="mb-4 md:mb-0 mr-1"
                        @click="removeItem"
                        icon="delete"
                        :disabled="selectedId ? false : true"
                    >Delete</vs-button>
                    <vs-button
                        class="mb-4 md:mb-0 mr-1"
                        @click="showFilter = true"
                        icon="filter_list"
                    >Filter</vs-button>
                    <vs-button
                        class="mb-4 md:mb-0 mr-1"
                        @click="printLabel"
                        icon="print"
                        :disabled="selectedId ? false : true"
                    >Print Label</vs-button>
                    <vs-dropdown>
                        <vs-button class="btn-drop" icon="expand_more">Spreadsheets</vs-button>
                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="getTemplate">Template</vs-dropdown-item>
                            <vs-dropdown-item @click="$refs.file.click()">Upload</vs-dropdown-item>
                            <input
                                type="file"
                                ref="file"
                                style="display: none"
                                v-on:change="uploadExcel"
                            />
                            <vs-dropdown-item
                                @click="exportExcel({ endpoint: 'master/containers/report/exportexcel', name: 'container', filter: filter })"
                            >Export</vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                    <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export</vs-button> -->
                </div>
            </div>
            <ag-grid-vue
                :gridOptions="gridOptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :rowData="data"
                colResizeDefault="shift"
                :animateRows="false"
                :floatingFilter="false"
                rowSelection="multiple"
                @selection-changed="onSelectionChanged"
            ></ag-grid-vue>
            <p class="text-right">
                <b>Showing {{ dataFrom }} to {{ dataTo }} of {{ dataTotal }} total entries</b>
            </p>
            <vs-pagination :total="totalPage" v-model="currentPage" :max="7"></vs-pagination>

            <vs-prompt @accept="filterData" title="Filter" :active.sync="showFilter">
                <div class="con-exemple-prompt">
                    <form v-on:submit.prevent="filterData">
                        <vs-input
                            label="Container ID"
                            v-model="filter.id"
                            class="mb-2 w-full"
                        />
                        <vs-input
                            label="Container Type"
                            v-model="filter.type"
                            class="mb-2 w-full"
                        />
                    </form>
                </div>
            </vs-prompt>

            <vs-prompt @accept="addData" title="Add Container" :active.sync="showAdd">
                <div class="con-exemple-prompt">
                    <form v-on:submit.prevent="addData">
                        <vs-input v-model="add.qty" class="mb-2 w-full" label="Quantity" />
                        <vs-input
                            label="Container Type"
                            v-model="add.type"
                            class="mb-2 w-full"
                        />
                    </form>
                </div>
            </vs-prompt>
        </vx-card>
    </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import {saveAs} from 'file-saver';

export default {
    components: {
        vSelect,
        AgGridVue
    },
    data() {
        return {
            gridOptions: {},
            gridApi: null,
            data: [],
            columnDefs: null,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true
            },
            selectedId: null,
            isLoading: false,
            maxRetry: 10,
            showFilter: false,
            filter: {
                id: "",
                type: ""
            },

            // Pagination
            totalPage: 0,
            currentPage: 1,
            dataFrom: 0,
            dataTo: 0,
            dataTotal: 0,

            // Add
            showAdd: false,
            add: {
                qty: 1,
                type: "Box"
            }
        };
    },
    watch: {
        isLoading: function() {
            if (this.isLoading) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        },
        currentPage: function() {
            this.fetchData();
        }
    },
    methods: {
        onSelectionChanged() {
            var selectedRows = this.gridApi.getSelectedRows();
            var selectedRowsString = "";
            selectedRows.forEach(function(selectedRow, index) {
                if (index !== 0) {
                    selectedRowsString += ", ";
                }
                selectedRowsString += selectedRow.id;
            });
            this.selectedId = selectedRowsString;
        },
        removeItem() {
            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: "Confirm",
                text: "Are you sure want to delete this container?",
                accept: this.acceptAlert
            });
        },
        fetchData() {
            this.isLoading = true;
            const filterParams = {
                id: this.filter.id,
                type: this.filter.type == "All" ? null : this.filter.type
            };
            this.$http
                .post(
                    "master/containers?page=" + this.currentPage,
                    filterParams
                )
                .then(res => {
                    this.data = res.data.data;
                    this.totalPage = res.data.last_page;
                    this.currentPage = this.currentPage;
                    this.dataTotal = res.data.total;
                    this.dataFrom = res.data.from;
                    this.dataTo = res.data.to;
                    this.isLoading = false;
                })
                .catch(resp => {
                    this.isLoading = false;
                    this.$vs.dialog({
                        type: "confirm",
                        color: "danger",
                        title: "Server Error",
                        text: "Try Again?",
                        accept: this.fetchData
                    });
                });
        },
        acceptAlert() {
            this.isLoading = true;
            this.$http.delete("master/containers/" + this.selectedId + "/destroy")
            .then(res => {
                this.$vs.notify({
                    color: "success",
                    title: "Success",
                    iconPack: "feather",
                    icon: "icon-check",
                    text: 'Data deleted.'
                });
                this.fetchData();
            })
            .catch(error => this.handleError(error))
        },
        refreshData() {
            this.fetchData();
        },
        filterData() {
            this.showFilter = false;
            if (this.currentPage == 1) {
                this.fetchData();
            } else {
                this.currentPage = 1;
            }
        },
        addData() {
            this.isLoading = true;
            this.$http
                .post("master/containers/store", this.add)
                .then(res => {
                    this.$vs.notify({
                        color: "success",
                        title: "Success",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: res.data.message
                    });
                    this.fetchData();
                })
                .catch(error => this.handleError(error))
        },
        printLabel() {
            this.isLoading = true;

            const id = this.gridApi.getSelectedRows().map(item => {
                return item.id;
            });

            this.$http
                .post(
                    "master/containers/print_label",
                    { id: id },
                    { responseType: "blob" }
                )
                .then(response => {
                    var blob = new Blob([response.data], {
                        type: "application/pdf"
                    });
                    window.open(URL.createObjectURL(blob));
                })
                .catch(error => console.log(error))
                .then(() => (this.isLoading = false));
        },
        getTemplate() {
            this.isLoading = true;
            this.$http
                .get("master/containers/report/gettemplate", {
                    responseType: "blob"
                })
                .then(response => {
                    this.isLoading = false;
                    saveAs(response.data, "container-upload-template.xlsx");
                });
        },
        uploadExcel() {
            let file = event.target.files[0];
            let form = new FormData();
            form.append("file", file);
            this.isLoading = true;
            this.$http
                .post("/master/containers/report/importexcel", form, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                })
                .then(resp => {
                    this.isLoading = false;
                    this.fetchData();
                    this.$vs.notify({
                        color: "success",
                        title: "Upload Success",
                        text: "Upload Data Containers Successfully"
                    });
                })
                .catch(error => this.handleError(error))
                .then(() => (this.isLoading = false));
        }
    },
    mounted() {
        this.fetchData();
        this.gridApi = this.gridOptions.api;
    },
    beforeMount() {
        this.columnDefs = [
            {
                headerName: "Container ID",
                field: "id",
                width: 120
            },
            {
                headerName: "Type",
                field: "type",
                width: 120
            },
        ];
        this.gridOptions.getRowHeight = function(params) {
            return 35;
        }
    }
};
</script>
